<template>
  <a class="icon-progreso" @click="irA()" >
    <div class="icon-progreso-imagen icon-progreso-imagen-total">
      <svg class="icon-progreso-imagen-porcentaje" xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 33.3 33.3' :stroke-dasharray="progreso" ><circle cx='16.65' cy='16.65' r='15.9155' fill='none' /></svg>
      <span class="icon-progreso-imagen-puntos" >{{ totalPuntos }}</span>
    </div>
    <span class="icon-progreso-descripcion">Puntos</span>
  </a>
</template>

<script>
export default {
  data() {
    return {
      puntos: 0
    }
  },
  computed: {
    totalPuntos() {
      return this.$store.getters.totalPuntosAnimado
    },
    porcentaje() {
      return Math.floor((this.$store.getters.totalPuntosAnimado / this.$store.getters.totalpuntajeDatosCliente) * 100.0)
    },
    progreso() {
      return '' + this.porcentaje + ', 100'
    }
  },
  methods: {
    
  }
}
</script>
